import { useEffect, useRef } from 'react';

interface UsePreviousOptions {
  disabled?: boolean;
}

// source: https://usehooks.com/usePrevious/
export function usePrevious<T>(value: T, options?: UsePreviousOptions): null | T {
  // The ref object is a generic container whose current property is mutable ...
  // ... and can hold any value, similar to an instance property on a class

  const ref = useRef<T>(null);
  // Store current value in ref
  useEffect(() => {
    if (!options?.disabled) {
      ref.current = value;
    }
  },
  [options?.disabled, value]); // Only re-run if value changes

  // Return previous value (happens before update in useEffect above)
  return ref.current;
}
